// Własne teksty maili z widgetu w Powiadomieniach (29.10.2026, migracja 073).
//
// Teksty domyślne i listę pól {{…}} podaje serwer w GET /api/notification-settings
// (`widgetEmailDefaults`, `widgetEmailVariables`, z Login/backend/lib/szablonyMailiWidgetu.js),
// więc panel nie trzyma ich kopii. Formularz ma zawsze wszystkie pięć maili z trzema polami,
// a serwer przy zapisie zostawia tylko pola różne od domyślnych.

export const RODZAJE_MAILI_WIDGETU = ['confirm', 'request', 'decline', 'unpaid_reminder', 'unpaid_cancel'];
export const POLA_MAILA_WIDGETU = ['subject', 'intro', 'outro'];

/** Pełny stan formularza: zapisany tekst firmy albo tekst domyślny. Null bez tekstów z serwera. */
export function szablonyDoFormularza(domyslne, zapisane) {
  if (!domyslne || typeof domyslne !== 'object') return null;
  const wynik = {};
  for (const rodzaj of RODZAJE_MAILI_WIDGETU) {
    const d = domyslne[rodzaj] || {};
    const z = (zapisane && typeof zapisane === 'object' && zapisane[rodzaj]) || {};
    wynik[rodzaj] = {};
    for (const pole of POLA_MAILA_WIDGETU) {
      wynik[rodzaj][pole] = typeof z[pole] === 'string' && z[pole].trim() ? z[pole] : (d[pole] || '');
    }
  }
  return wynik;
}

/** Czy mail ma choć jedno pole inne niż domyślne (odznaka „Własny tekst”). */
export function maWlasnyTekst(szablony, domyslne, rodzaj) {
  if (!szablony || !domyslne || !szablony[rodzaj] || !domyslne[rodzaj]) return false;
  return POLA_MAILA_WIDGETU.some((pole) => String(szablony[rodzaj][pole] || '').trim() !== String(domyslne[rodzaj][pole] || '').trim());
}
